import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'grid' | 'list';
}

export default function MovieCard({ movie, variant = 'grid' }: MovieCardProps) {
  if (variant === 'list') {
    return (
      <Link
        to={`/movie/${movie.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:border-primary-300 hover:bg-background-100"
      >
        <div className="relative h-[168px] w-[112px] shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={movie.cover}
            alt={`${movie.title} 影视作品封面`}
            title={`${movie.title} 河北彩花影视作品`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-start justify-between gap-2">
            <h3 className="truncate text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
              {movie.title}
            </h3>
            <span className="flex shrink-0 items-center gap-1 rounded-md bg-accent-100 px-2 py-0.5 text-xs font-semibold text-accent-900">
              <i className="ri-star-fill"></i>
              {movie.rating.toFixed(1)}
            </span>
          </div>
          <p className="mt-1.5 text-xs text-foreground-500">
            {movie.type} · {movie.year} · {movie.region} · {movie.duration}
          </p>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{movie.summary}</p>
          <div className="mt-auto flex flex-wrap gap-1.5 pt-3">
            {movie.genres.slice(0, 3).map((genre) => (
              <span key={genre} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                {genre}
              </span>
            ))}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 影视作品封面`}
          title={`${movie.title} 河北彩花影视作品`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-accent-950">
          <i className="ri-star-fill"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {movie.year} · {movie.genres[0]}
        </p>
      </div>
    </Link>
  );
}